export default __webpack_public_path__ + "static/step0402-8d2401ea5636338b0753941d44a5cc67.jpg";